<script lang="ts">
    import { getContext } from 'svelte'
    import { derived as sderived } from 'svelte/store'
    import type { Readable } from 'svelte/store'

    import { gettext as _ } from 'hydria/services/gettext'
    import { simpleFetch, groups as userGroups } from 'hydria/services/session'
    import { notify } from 'hydria/services/notifications'

    import type { AdminData, MiscData, User, UserHandler } from './user'

    import LoadingPattern from 'hydria/components/LoadingPattern.svelte'
    import { sanchor, spath } from 'hydria/svelte_helpers'

    const userh = <UserHandler>getContext('User')

    const status = sderived(userh.status, ($status) => $status)
    const loading = sderived(userh.loading, ($loading) => $loading)

    const user: Readable<User> = sderived(userh.userWritable, ($v) => $v)
    const mdata: Readable<MiscData> = sderived(userh.miscData, ($v) => $v)
    const adata: Readable<AdminData> = sderived(userh.adminData, ($v) => $v)

    let mode: null | 'edit' = $state(null)
    let editAdminSlots = $state(0)
    let working = $state(false)

    async function setSlots() {
        working = true
        try {
            const r = await simpleFetch('POST', `/json/zone/1/user/${$user.id}/free-slots`, { n_slots: editAdminSlots })
            Object.assign(userh.raw, {
                slots: r.data.slots,
                n_avail_slots: r.data.n_avail_slots,
                n_inuse_slots: r.data.n_inuse_slots,
            })
            Object.assign(userh.raw.user_admin_data, {
                administrative_slots: r.data.n_admin_slots,
            })
            userh.loadMiscData()
            userh.loadAdminData()
        } catch (e) {
            console.error('Error:', e)
            notify({
                type: 'danger',
                title: 'Slots administratifs',
                text: 'Erreur de sauvegarde',
            })
        }
        working = false
        mode = null
    }
</script>

<div class="card">
    <div class="card-title text-primary">{$_('Zones')}</div>
    {#if $status == 'loading' || $loading}
        <div class="card-body">
            <LoadingPattern pattern={[50, 45]} />
        </div>
    {:else if $userGroups.has('global-domain-admin')}
        <div class="card-body">
            {#if mode == 'edit'}
                <form
                    onsubmit={(e) => {
                        e.preventDefault()
                        setSlots()
                    }}
                >
                    <div class="form-group">
                        <input type="number" class="form-control" min={0} disabled={working} bind:value={editAdminSlots} placeholder="Nombre de slots adminstratifs (gratuits, sans expiration)" />
                    </div>
                    <div class="btn-toolbar">
                        <button class="btn btn-primary btn-sm" type="submit" disabled={working || editAdminSlots == null || editAdminSlots == $adata.administrative_slots || editAdminSlots < 0}>
                            {#if working}
                                <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                                Sauvegarde…
                            {:else}
                                Sauvegarder
                            {/if}
                        </button>
                        <button class="btn btn-outline-secondary btn-sm" type="button" disabled={working} onclick={() => (mode = null)}>Annuler</button>
                    </div>
                </form>
            {:else}
                <ul class="list-unstyled">
                    <li>
                        Slots: <strong>{$mdata.n_inuse_slots} / {$mdata.n_avail_slots}</strong> in use; <strong>{$adata.administrative_slots}</strong> admin slots (<button
                            type="button"
                            class="btn btn-link btn-a"
                            onclick={() => {
                                editAdminSlots = $adata.administrative_slots
                                mode = 'edit'
                            }}>éditer</button
                        >) ;
                    </li>
                    <li><a use:sanchor href={spath(`/zones?owner=${$user.id}`)}>List user’s zones (pub: {$mdata.published_count}; unpub: {$mdata.unpublished_count})</a>.</li>
                </ul>
            {/if}
        </div>
    {/if}
</div>
